var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.938,
    y2: 0.577,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#265df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "day-sunny",
    d: "M0,7A.554.554,0,0,1,.167,6.59a.565.565,0,0,1,.4-.161H1.908a.491.491,0,0,1,.38.167A.577.577,0,0,1,2.44,7a.565.565,0,0,1-.151.4.5.5,0,0,1-.38.164H.562a.539.539,0,0,1-.4-.167A.542.542,0,0,1,0,7Zm1.883,4.564a.584.584,0,0,1,.154-.4l.97-.939a.514.514,0,0,1,.389-.154.55.55,0,0,1,.392.148.5.5,0,0,1,.158.377.609.609,0,0,1-.161.42l-.939.939a.6.6,0,0,1-.809,0,.555.555,0,0,1-.154-.389Zm0-9.122a.584.584,0,0,1,.154-.4.639.639,0,0,1,.42-.161.557.557,0,0,1,.389.161l.939.97a.5.5,0,0,1,.161.389.539.539,0,0,1-.55.55.5.5,0,0,1-.389-.161l-.97-.938a.578.578,0,0,1-.154-.408ZM3.563,7a3.342,3.342,0,0,1,.463-1.714A3.432,3.432,0,0,1,5.283,4.027,3.353,3.353,0,0,1,7,3.563a3.311,3.311,0,0,1,1.328.275,3.5,3.5,0,0,1,1.1.735,3.439,3.439,0,0,1,.732,1.1,3.41,3.41,0,0,1-.188,3.045,3.4,3.4,0,0,1-1.251,1.25,3.434,3.434,0,0,1-3.434,0,3.43,3.43,0,0,1-1.253-1.25A3.34,3.34,0,0,1,3.563,7Zm2.872,5.12a.532.532,0,0,1,.164-.4.578.578,0,0,1,.8,0,.537.537,0,0,1,.161.4v1.309a.56.56,0,0,1-.164.408.559.559,0,0,1-.8,0,.56.56,0,0,1-.164-.408Zm0-10.209V.562A.539.539,0,0,1,6.6.167a.551.551,0,0,1,.79,0,.541.541,0,0,1,.167.4V1.908a.5.5,0,0,1-.164.38.6.6,0,0,1-.8,0,.494.494,0,0,1-.164-.38Zm3.637,8.683a.517.517,0,0,1,.519-.525.535.535,0,0,1,.4.154l.963.939a.572.572,0,0,1,.161.4.53.53,0,0,1-.161.389.583.583,0,0,1-.791,0l-.939-.939a.609.609,0,0,1-.148-.42Zm0-7.195a.513.513,0,0,1,.148-.389l.939-.97a.557.557,0,0,1,.389-.161.537.537,0,0,1,.4.167.545.545,0,0,1,.164.4.552.552,0,0,1-.161.408l-.963.939a.579.579,0,0,1-.4.161.488.488,0,0,1-.371-.158.55.55,0,0,1-.148-.392ZM11.56,7a.579.579,0,0,1,.161-.408.516.516,0,0,1,.377-.161h1.334A.581.581,0,0,1,14,7a.533.533,0,0,1-.17.4.551.551,0,0,1-.4.167H12.1a.505.505,0,0,1-.383-.164A.559.559,0,0,1,11.56,7Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sun.7dd7a00f19ffdb37eeb90be915c1cc54.svg";